export default "__VITE_ASSET__43dd7069__"